/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_item = {
    readonly serviceId: string | null;
    readonly firstPhotoWebPath: string | null;
    readonly title: string | null;
    readonly defaultSkuId: string | null;
    readonly itemType: string | null;
    readonly isListingUnlisted: boolean | null;
    readonly seller?: {
        readonly isAccessible: boolean | null;
        readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarSellerInfo_seller">;
    } | null;
    readonly internalBuyLinks?: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"SharedRespLinksBlock_links">;
    } | null> | null;
    readonly skus: ReadonlyArray<{
        readonly serviceId: string | null;
        readonly skuLeadTime: string | null;
        readonly " $fragmentRefs": FragmentRefs<"PdpRespDealerDetails_sku" | "PriceDisplay_sku" | "PdpRespSidebarBlurbs_sku">;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedEditorialArticles_item" | "PdpRespStorytellingModule_item" | "PdpRespExitModal_item" | "PdpRespSimilarItemsLanding_item" | "PdpRespBreadcrumbs_item" | "PdpRespHeroCarouselPrint_item" | "PdpRespTitle_item" | "PdpRespSidebarButtons_item" | "PdpRespSidebarBlurbs_item" | "PdpRespShippingReturns_item" | "PdpRespSidebarContact_item" | "PdpRespSimilarItemsFooter_item" | "PdpSharedQuantitySelect_item" | "PdpSharedRecentHistoryTracker_item" | "SharedRespLinksBlock_item" | "PriceDisplay_item" | "PdpRespSwatchSelector_item" | "PdpSharedShippingBadge_item" | "PdpSharedFrameIncluded_item" | "PdpRespDealerDetails_item" | "PdpRespAboutModule_item" | "PdpRespRingSize_item" | "PdpRespHeroCarousel_item">;
    readonly " $refType": "PdpRespContainer_item";
};
export type PdpRespContainer_item$data = PdpRespContainer_item;
export type PdpRespContainer_item$key = {
    readonly " $data"?: PdpRespContainer_item$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_item">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v1 = {
  "kind": "Variable",
  "name": "hasUserId",
  "variableName": "fetchUser"
},
v2 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v3 = {
  "kind": "Variable",
  "name": "userId",
  "variableName": "userId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchPdp"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "isMultiSku"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainer_item",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "small"
        }
      ],
      "kind": "ScalarField",
      "name": "firstPhotoWebPath",
      "storageKey": "firstPhotoWebPath(size:\"small\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "defaultSkuId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "itemType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isListingUnlisted",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSkuType",
      "kind": "LinkedField",
      "name": "skus",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": "skuLeadTime",
          "args": [
            {
              "kind": "Literal",
              "name": "pageType",
              "value": "PDP"
            }
          ],
          "kind": "ScalarField",
          "name": "leadTime",
          "storageKey": "leadTime(pageType:\"PDP\")"
        },
        {
          "condition": "isMultiSku",
          "kind": "Condition",
          "passingValue": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespDealerDetails_sku"
            },
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "hasSkuId",
                  "value": true
                },
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/)
              ],
              "kind": "FragmentSpread",
              "name": "PriceDisplay_sku"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSidebarBlurbs_sku"
            }
          ]
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedEditorialArticles_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespStorytellingModule_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespExitModal_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsLanding_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespBreadcrumbs_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespHeroCarouselPrint_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespTitle_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespShippingReturns_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarContact_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsFooter_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedQuantitySelect_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedRecentHistoryTracker_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedRespLinksBlock_item"
    },
    {
      "args": [
        (v1/*: any*/),
        (v2/*: any*/),
        (v3/*: any*/)
      ],
      "kind": "FragmentSpread",
      "name": "PriceDisplay_item"
    },
    {
      "condition": "isMultiSku",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespSwatchSelector_item"
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingBadge_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedFrameIncluded_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespDealerDetails_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespAboutModule_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespRingSize_item"
    },
    {
      "condition": "fetchPdp",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Seller",
          "kind": "LinkedField",
          "name": "seller",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAccessible",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PdpRespSidebarSellerInfo_seller"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "InternalBuyLinkType",
          "kind": "LinkedField",
          "name": "internalBuyLinks",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SharedRespLinksBlock_links"
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespHeroCarousel_item"
        }
      ]
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();
(node as any).hash = '4fbb66115bdc56289917485064a480ec';
export default node;
